export default {
  message: {
    "error": "Wystąpił błąd!",
    "Sorrysomeerrorsoccurred": "Przepraszamy, wystąpiły pewne błędy",
    "quit": "Wyjdź",
    "language": "Język",
    "Youcanchangethelanguagehere": "Możesz zmienić język tutaj!",
    "current": "Bieżący",
    "home": "Strona główna",
    "friends": "Znajomi",
    "wallet": "Portfel",
    "aboutus": "O nas",
    "Sharewithfriends": "Podziel się z przyjaciółmi",
    "copyFailure": "Kopia nieudana",
    "copySuccess": "Kopia udana",
    "Claimreward": "Odbierz nagrodę",
    "DailyLogin": "Codzienne logowanie",
    "noInvitationsYet": "Brak zaproszeń",
    "LoadMore": "Załaduj więcej",
    "WatchAD": "Obejrzyj REKLAMĘ",
    "continue": "Kontynuuj",
    "Congratulations": "Gratulacje",
    "MyFriends": "Moi znajomi",
    "Invitefriends": "Zaproś znajomych",
    "Invitepremiumfriends": "Zaproś premium znajomych",
    "DailyTasks": "Codzienne zadania",
    "inviteDesc": "+{num} ${name} za każdego znajomego, którego zaprosisz",
    "DailyTasksDesc": "Wykonuj zadania, aby zdobyć więcej ${name}",
    "SponsorsandPartners": "Sponsorzy i partnerzy",
    "Receivingwallet": "Portfel do odbioru",
    "Enterwalletaddress": "Wprowadź adres portfela {name}",
    "Claim": "Odbierz",
    "Booster": "Booster",
    "RentPeriod": "Okres wynajmu",
    "days30": "30 dni",
    "days": "dni",
    "Dailyprofit": "Dzienny zysk",
    "Totalprofit": "Całkowity zysk",
    "Quantity": "Ilość",
    "RentPrice": "Cena wynajmu",
    "RentMiner": "Wynajmij minera",
    "Insufficient": "Niewystarczająca ${name}",
    "InsufficientMsg": "Potrzebne {num} ${name1}, zaproś znajomych lub wykonuj zadania, aby zarobić więcej ${name2}.",
    "Settings": "Ustawienia",
    "copyid": "Skopiuj ID",
    "UpgradeSuccessfully": "Ulepszono pomyślnie",
    "Name": "Nazwa",
    "userinfo": "Informacje o użytkowniku",
    "disconnect": "Rozłącz",
    "Startmining": "Rozpocznij kopanie",
    "Welcome": "Witamy w {name}",
    "Withdrawal": "Wypłata",
    "Minimumamount": "Minimalna kwota",
    "Networkfee": "Opłata sieciowa",
    "Enteramount": "Wprowadź kwotę",
    "Submit": "Wyślij",
    "MinimumTip": "Kwota wypłaty jest za mała. Minimalna kwota wypłaty: {num}",
    "MaximumTip": "Niewystarczająca kwota, maksymalna kwota, jaką możesz wypłacić, to: {num}",
    "SubmittedTip": "Przesłano, oczekiwane przetworzenie w ciągu 30-60 dni roboczych",
    "WebSubmittedTip": "Przesłano, oczekiwane przetworzenie w ciągu 24-48 godzin",
    "WithdrawStatus": "Status",
    "Submissiontime": "Czas zgłoszenia",
    "WithdrawAwaitTip": "* Szacuje się, że zajmie to 30-60 dni roboczych. Zapraszanie większej liczby znajomych może przyspieszyć proces weryfikacji.",
    "WebWithdrawAwaitTip": "* Szacuje się, że zajmie to 24-48 godzin. Zapraszanie większej liczby znajomych może przyspieszyć proces weryfikacji.",
    "Processing": "W przetwarzaniu",
    "Success": "Sukces",
    "Rejection": "Odmowa",
    "Amount": "Kwota",
    "Numberoffriends": "Liczba znajomych: {now}/{limit}",
    "InviteTip": "Aby dokonać pierwszej wypłaty, musisz zaprosić {limit} znajomych do dołączenia do aplikacji wydobywczej.",
    "openonphone": "Otwórz ten link na swoim telefonie.",
    "claimTip": "Kwota do odebrania jest za mała. Minimalna kwota do odebrania to: {num}",
    "WalletBalance": "Saldo portfela",
    "Withdraw": "Wypłać",
    "SetWalletAddress": "Ustaw adres portfela",
    "WithdrawalRecord": "Rekord wypłat",
    "Norecords": "Brak rekordów",
    "Whatis": "Czym jest {name}?",
    "All": "Wszystko",
    "save": "Zapisz",
    "successWithdrawal": "Wypłata została odebrana {num}",
    "secondsago": "{time} sekund temu",
    "Loading": "Ładowanie...",
    "PaymentConfirming": "Sprawdzanie statusu transakcji...",
    "Check": "Sprawdź",
    "CheckFail": "Transakcja nie została zakończona. Proszę sprawdzić ponownie za 5 sekund.",
    "Addname": "Dodaj '{name}' do swojego imienia",
    "Restattcheck": "Uruchom ponownie aplikację, aby sprawdzić",
    "Copyname": "Skopiuj '{name}'",
    "SubmissionFailed": "Nieudane zgłoszenie, spróbuj ponownie później",
    "WithdrawalReview": "Weryfikacja wypłaty",
    "shop": "Sklep",
    "topurchase": "Przejdź do sklepu, aby zakupić",
    "shopDesc": "Ograniczona dostępność – zdobądź swoją, zanim znikną!",
    "select_payment_method": "Wybierz metodę płatności",
    "total_amount": "Łączna kwota",
    "creating_order": "Tworzenie zamówienia...",
    "order_created": "Zamówienie utworzone",
    "order_status": "Status zamówienia",
    "claim": "Odbierz",
    "payment_success": "Płatność zakończona pomyślnie",
    "payment_failed": "Płatność nie powiodła się",
    "payment_cancelled": "Płatność anulowana",
    "opening_payment": "Otwarcie płatności...",
    "payment_status": "Status płatności",
    "create_order_failed": "Nie udało się utworzyć zlecenia",
    "creating_ton_order": "Tworzenie zlecenia TON...",
    "next_step": "Następny krok",
    "use_ton_payment": "Użyj płatności TON",
    "start_transaction": "Rozpocznij transakcję",
    "connect_wallet": "Połącz portfel",
    "address": "Adres",
    "amount_ton": "Kwota TON",
    "copy": "Kopiuj",
    "amount": "Kwota",
    "wallet_address": "Adres portfela",
    "comment_memo": "Notatka komentarz",
    "you_can_choose_to_connect_wallet_to_pay": "Możesz wybrać połączenie portfela, aby zapłacić",
    "or_manually_transfer_to_the_above_address": "Lub ręcznie przelać na powyższy adres (zauważ, że kwota i notatka muszą być dokładnie takie same)",
    "transaction_success": "Transakcja zakończona sukcesem",
    "transaction_failed": "Transakcja nie powiodła się",
    "transaction_error": "Błąd transakcji",
    "transaction_status": "Status transakcji",
    "transaction_id": "ID transakcji",
    "transaction_amount": "Kwota transakcji",
    "transaction_status_desc": "Opis statusu transakcji",
    "payment_status_tip": "Proszę czekać na potwierdzenie płatności",
    "Applyforwithdrawal": "Ubiegaj się o wypłatę",
    "Withdrawalunlock": "Odblokowywanie wypłaty",
    "Close": "Zamknij",
    "Delivering": "Dostawa",
    "Duetothelargenumber": "Z powodu dużej liczby odbiorców, twój airdrop spodziewany jest w ciągu 15-20 dni roboczych",
    "WithdrawalunlockTip": "Potrzebujesz {num} zaproszonych przyjaciół, aby ukończyć zadania/podwiązać portfele w celu odblokowania wypłaty",
    "select_network": "Wybierz sieć",
    "confirm": "potwierdź",
    "switching_network": "Przełączanie sieci...",
    "network_switched": "Sieć zmieniona",
    "use_usdt_payment": "Użyj płatności USDT",
    "or_manually_transfer_to_the_above_address_usdt": "Ręcznie przekaż na powyższy adres (zauważ, że kwota i adres muszą być dokładnie takie same)",
    "chain_type": "Sieć",
    "check_transaction_status": "Sprawdź status transakcji",
    "transaction_wait": "Transakcja jest w toku. Możesz opuścić aplikację. Otrzymasz powiadomienie, gdy będzie zakończona.",
    "twa_pay_tip_with_memo": "Proszę upewnić się, że adres, kwota i memo są zgodne z transferem.",
    "twa_pay_tip": "Proszę upewnić się, że adres i kwota są poprawne dla transferu.",
    "creating_usdt_order": "Tworzenie zamówienia USDT...",
    "affiliate_programs": "Programy partnerskie",
    "affiliate_programs_description": "Zaprosić przyjaciół do dołączenia do aplikacji wydobywczej i zdobyć nagrody.",
    "commission_details": "Szczegóły prowizji",
    "no_commission_records": "Brak zapisów prowizji",
    "commission_list": "Lista prowizji",
    "input_amount": "Wprowadź kwotę",
    "max": "Maks",
    "commission_input_amount": "Wprowadź kwotę prowizji",
    "min_commission": "Minimalna kwota wypłaty wynosi {num}",
    "WithdrawalSuccess": "Wypłata zakończona sukcesem",
    "WithdrawalFailed": "Wypłata nie powiodła się",
    "WithdrawalProcessing": "Wypłata w toku",
    "award": "Nagroda",
    "level": "Poziom",
    "Share_to_group": "Udostępnij w grupie",
    "Exchange": "Wymiana",
    "balance_not_enough": "Saldo niewystarczające, możesz wymienić tylko {num} {coin}",
    "exchange_fail": "Wymiana nieudana",
    "exchange_success": "Wymiana udana",
    "you_will_receive": "Otrzymasz",
    "ShareToGroups": "Udostępnij do grup",
    "Numberofgroups": "Liczba grup: {now}/{limit}",
    "Confirm": "Potwierdź",
    "ShareToGroupsDesc": "Udostępnij do grup, aby zdobyć więcej {name}",
    "TokenAddress": "Proszę wprowadzić dane wypłaty, takie jak identyfikator wymiany lub adres USDT",
    "CashAddress": "Proszę wprowadzić dane wypłaty, takie jak numer karty bankowej lub adres USDT",
    "Cancel": "Anuluj",
    "min_withdrawal_amount": "Minimalna kwota wypłaty wynosi {num} {coin}",
    "max_withdrawal_amount": "Maksymalna kwota wypłaty wynosi {num} {coin}",
    "withdrawal_failed": "Wypłata nie powiodła się",
    "withdrawal_success": "Wypłata zakończona sukcesem",
    "PayNow": "Zapłać teraz",
    "PaySkip": "Zapłać {num}, aby natychmiast odblokować wypłatę",
    "NumberofGroups": "Liczba grup: {now}/{limit}",
    "SendMessage": "Wyślij wiadomość",
    "NumberofShares": "Liczba udziałów: {now}/{limit}",
    "NumberofTasks": "Liczba zadań: {now}/{limit}",
    "CompleteTask": "Wykonaj zadanie",
    "PleaseEnterValidAmount": "Proszę wprowadzić prawidłową kwotę",
    "PleaseEnterValidEmail": "Proszę wprowadzić prawidłowy adres e-mail",
    "Feedback": "Opinie",
    "Inputfeedbackcontent": "Wprowadź treść opinii",
    "Submitfeedback": "Prześlij opinię",
    "Pleaseenteravalidemailaddress": "Proszę wprowadzić prawidłowy adres e-mail",
    "Pleaseenteryouremailaddress": "Proszę wprowadzić swój adres e-mail",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "Już wysłałeś opinię dzisiaj, wróć jutro",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "Opinia została pomyślnie przesłana, dziękujemy za cenne uwagi",
    "Feedback_submission_failed_please_retry": "Wysyłanie opinii nie powiodło się, spróbuj ponownie",
    "ContactUs": "Skontaktuj się z nami",
    "XRPAddress": "Proszę wpisać aktywowany adres portfela XRP (łącznie z MEMO), w przeciwnym razie nie będziesz mógł wycofać gotówki.",
    "Accelerated": "Przyspieszony",
    "Accelerated_withdrawals_success": "Przyspieszone wypłaty z sukcesem",
    "login": "Zaloguj się",
    "register": "Zarejestruj się",
    "login_with_google": "Zaloguj się przez Google",
    "or": "LUB",
    "email": "Email",
    "password": "Hasło",
    "no_account": "Nie masz konta",
    "click_to_go": "Kliknij, aby",
    "have_account": "Masz już konto",
    "go_to": "Przejdź do",
    "invite_code": "Kod zaproszenia",
    "optional": "Opcjonalnie",
    "google_login_not_ready": "Logowanie przez Google nie jest gotowe, spróbuj ponownie później",
    "password_too_long": "Hasło jest za długie",
    "weak": "Słabe",
    "medium": "Średnie",
    "strong": "Silne",
    "login_success": "Zalogowano pomyślnie",
    "login_failed": "Logowanie nie powiodło się",
    "please_input_email": "Proszę wprowadzić swój email",
    "invalid_email": "Nieprawidłowy format emaila",
    "please_input_password": "Proszę wprowadzić swoje hasło",
    "password_length_6_to_16": "Hasło musi mieć od 6 do 16 znaków",
    "account_or_password_error": "Błąd konta lub hasła",
    "register_success": "Rejestracja zakończona sukcesem",
    "register_failed": "Rejestracja nie powiodła się",
    "save_error": "Błąd zapisu, spróbuj ponownie później",
    "ShareToFriends": "Udostępnij znajomym",
    "login_first": "Proszę najpierw się zalogować",
    "WalletBscError": "❌ Nieprawidłowy adres portfela BNB Chain.",
    "DownloadWallet": "Pobierz portfel",
    "AddToHomeScreen": "Dodaj {appName} do ekranu głównego",
    "TapShareInToolbar": "Dotknij w pasku narzędzi",
    "SelectAddToHomeScreen": "Wybierz dodaj do ekranu głównego",
    "OpenToolbar": "Otwórz pasek narzędzi",
    "ClaimFailed": "Nie udało się odebrać nagrody, spróbuj ponownie później",
    "guest_login": "Logowanie gościa",
    "please_input_phone": "Proszę wprowadzić swój numer telefonu",
    "email_error_1": "Proszę wprowadzić swój adres e-mail",
    "email_error_2": "Proszę wprowadzić poprawny adres e-mail",
    "email_error_3": "Adres e-mail gościa nie jest dozwolony, proszę użyć prawdziwego adresu e-mail",
    "phone": "Telefon",
    "phone_error_1": "Proszę wprowadzić swój numer telefonu",
    "phone_error_2": "Proszę wprowadzić poprawny numer telefonu",
    "update_info": "Aktualizuj informacje",
    "update_success": "Aktualizacja zakończona sukcesem",
    "update_failed": "Aktualizacja nie powiodła się, proszę spróbować później",
    "cancel": "Anuluj",
    "guest_credentials_title": "Informacje o koncie",
    "guest_credentials_warning": "Proszę zrób zrzut ekranu, aby zapisać swoje konto i hasło. W przypadku zgubienia, twoje zarobki nie mogą być odzyskane!",
    "i_have_saved": "Zapisałem",
    "account": "Konto",
    "view_credentials": "Wyświetl dane logowania",
    "miner_max_reached": "Osiągnąłeś maksymalną liczbę tego górnika"
}};